module.exports = __webpack_public_path__ + "assets/img/ginko.a3b70fab.png";